
export const PageNotFound = () => {
    return (


<div>ThankYou For Submiting!..</div>   
 )
  }
  